export enum Permissions {
  USER_ONBOARDING = 'USER_ONBOARDING',
  SCHEDULING = 'SCHEDULING',
  VIEW_PATIENTS = 'VIEW_PATIENTS',
  UPDATING_APPOINTMENTS = 'UPDATING_APPOINTMENTS',
  VIEW_PATIENT_NOTES = 'VIEW_PATIENT_NOTES',
  PATIENT_CONFIDENTIAL_HEALTH_DETAILS = 'PATIENT_CONFIDENTIAL_HEALTH_DETAILS',
  BILLING = 'BILLING',
  PATIENT = 'PATIENT',
  RECEPTION = 'RECEPTION',
  DOCTOR = 'DOCTOR',
  MANAGER = 'MANAGER',
}
